import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  id: "app_pc",
  class: "app-inner"
};
const _hoisted_2 = {
  id: "navigator",
  class: "navigator"
};
const _hoisted_3 = {
  id: "app-body",
  class: "app-body"
};
const _hoisted_4 = {
  key: 0,
  id: "app-foot"
};
import { useRouter } from "vue-router";
import navigator from "./components_pc/common/common_nav.vue";
import foot from "./components_pc/common/common_foot.vue";

// 判断footer是否需要显示。如果页面的url来自于purchase及其子页面，则不显示footer
import { ref } from "vue";
export default {
  __name: 'App_pc',
  setup(__props) {
    const router = useRouter();
    const isShowFooter = ref(true);
    const currentPath = router.currentRoute.value.path;
    // 如果url中有purchase，则不显示footer
    if (currentPath.includes("purchase")) {
      isShowFooter.value = false;
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(navigator)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view), isShowFooter.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(foot)])) : _createCommentVNode("", true)])]);
    };
  }
};